module.exports = __webpack_public_path__ + "img/reason-manage.fbecf95c.png";